import {
  CookieKeyTypeEnum,
  setCookieItem,
  removeCookieItem,
} from './cookie-domain'

export const saveChoosePickUp = () => {
  const expirationTime = new Date()
  expirationTime.setHours(expirationTime.getHours() + 8)

  setCookieItem(CookieKeyTypeEnum.isPickUpChoose, 'true', {
    expires: expirationTime,
  })
}

export const removeChoosePickUp = () => {
  removeCookieItem(CookieKeyTypeEnum.isPickUpChoose)
}
